import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
export default class SupporterClubCard extends Component {
  view(vnode) {
    const club = vnode.attrs.club;
    return m("div", {
      className: "SupporterClub-card-container",
      key: "supporter-club-card"
    }, m("div", {
      className: "SupporterClub-card"
    }, club.imagePath() && m("div", {
      className: "SupporterClub-image-container"
    }, m("img", {
      className: "SupporterClub-image",
      src: "/assets/extensions/nagusi-match-ratings/escudo/".concat(club.imagePath()),
      alt: club.name()
    })), m("div", {
      className: "SupporterClub-info"
    }, m("h2", {
      className: "SupporterClub-title"
    }, club.name()), club.foundedAt() && m("div", {
      className: "SupporterClub-founded"
    }, app.translator.trans('nagusi-match-ratings.supporter-clubs.forum.card.founded'), " ", new Date(club.foundedAt()).getFullYear()), m("div", {
      className: "SupporterClub-contact"
    }, club.email() && m("div", null, m("i", {
      className: "fas fa-envelope"
    }), " ", m("a", {
      href: "mailto:".concat(club.email())
    }, club.email())), club.address() && m("div", null, m("i", {
      className: "fas fa-map-marker-alt"
    }), " ", club.address())), club.description() && m("div", {
      className: "SupporterClub-description"
    }, m.trust(club.description())), (club.websiteUrl() || club.facebookUrl() || club.instagramUrl() || club.twitterUrl()) && m("div", {
      className: "SupporterClub-socials"
    }, club.websiteUrl() && m("a", {
      className: "SupporterClub-social-link",
      href: club.websiteUrl(),
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fas fa-globe"
    })), club.facebookUrl() && m("a", {
      className: "SupporterClub-social-link",
      href: club.facebookUrl(),
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fab fa-facebook"
    })), club.instagramUrl() && m("a", {
      className: "SupporterClub-social-link",
      href: club.instagramUrl(),
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fab fa-instagram"
    })), club.twitterUrl() && m("a", {
      className: "SupporterClub-social-link",
      href: club.twitterUrl(),
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fab fa-twitter"
    }))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/supporter-clubs/SupporterClubCard', SupporterClubCard);